import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createConsentAwareJSONStorage } from '../utils/consentAwareStorage';

export type Voice = 'alloy' | 'ash' | 'ballad' | 'coral' | 'echo' | 'fable' | 'nova' | 'onyx' | 'sage' | 'shimmer';
export type Speed = 0.5 | 1 | 1.5 | 2;

interface TTSState {
  voice: Voice;
  speed: Speed;
  showModal: boolean; // Глобальное состояние для видимости панели TTS
  currentText: string | null; // Текст, который сейчас воспроизводится
  setVoice: (voice: Voice) => void;
  setSpeed: (speed: Speed) => void;
  setShowModal: (show: boolean) => void;
  setCurrentText: (text: string | null) => void;
  closeModal: () => void;
}

const useTTSStore = create<TTSState>()(
  persist(
    (set) => ({
      voice: 'coral',
      speed: 1,
      showModal: false, // По умолчанию скрыта
      currentText: null, // Нет текущего текста
      setVoice: (voice: Voice) => set({ voice }),
      setSpeed: (speed: Speed) => set({ speed }),
      setShowModal: (show: boolean) => set({ showModal: show }),
      setCurrentText: (text: string | null) => set({ currentText: text }),
      closeModal: () => set({ showModal: false, currentText: null }),
    }),
    {
      name: 'tts-storage',
      storage: createConsentAwareJSONStorage(), // .ru: гейтится functional consent (FZ-152)
      // Не сохраняем showModal и currentText в localStorage - они всегда сбрасываются при загрузке
      partialize: (state) => ({ voice: state.voice, speed: state.speed }),
    }
  )
);

export { useTTSStore };
